import React from 'react';
import { Select } from 'antd';
export const GraphLines = [
    {
        label: 'Arc',
        value: 'arc'
    },
    {
        label: 'Cubic',
        value: 'cubic'
    },
    {
        label: 'Cubic Horizontal',
        value: 'cubic-horizontal'
    },
    {
        label: 'Cubic Vertical',
        value: 'cubic-vertical'
    },
    {
        label: 'Graphin Line',
        value: 'graphin-line'
    },
    {
        label: 'Line',
        value: 'line'
    },
    {
        label: 'Polyline',
        value: 'polyline'
    },
    {
        label: 'Quadratic',
        value: 'quadratic'
    },
    {
        label: 'Read Low',
        value: 'read-low'
    },
    {
        label: 'Read High',
        value: 'read-high'
    },
    {
        label: 'Read Write Low',
        value: 'readwrite-low'
    },
    {
        label: 'Read Write High',
        value: 'readwrite-high'
    },
    {
        label: 'Calculated',
        value: ''
    }
];
export const GraphLineSelector = (props) => React.createElement(Select, Object.assign({ options: GraphLines, popupMatchSelectWidth: false }, props));
